import { loadScript } from '@mbrtargeting/metatag-utils';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { onPhase, Phase } from '../../../loader/decorators/on-phase.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { selectModuleSettings } from '../../../loader/essentials/config-selector.js';
import { logger } from '../../../loader/essentials/logger.js';
import { ConsentCache } from '../../../loader/modules/consent-cache.js';
import { CONFIG_RESOLVER, CONSENT_CACHE } from '../../../loader/token.js';
import { ID_STORE } from '../../token.js';
import { IdStore } from '../idstore/idstore.js';

const log = logger.logGroup({ prefix: 'AudienceProject' });

declare var window: Window & yieldlove.Window & {
    audienceProjectLayer?: Array<[cmd: 'setUserId', idName: string, idValue: string]>;
};

@injectionTarget()
export class AudienceProject {

    @inject(CONFIG_RESOLVER) #configResolver!: ConfigResolver;
    @inject(ID_STORE) #idStore!: IdStore;
    @inject(CONSENT_CACHE) #consentCache!: ConsentCache;

    @onPhase({ phase: Phase.TRACKING })
    async generateAudienceProjectPixel() {

        const { active = false, iabVendorId = 0, url } = this.#configResolver.get(selectModuleSettings('AUDIENCE_PROJECT')) || {};

        if (!active) return log.debug('module not active');
        if (!url) return log.debug('url not set');

        const allowed = await this.#consentCache.whenConsentConditions([
            { consentedVendors: [iabVendorId] },
            { legitimateInterestVendors: [iabVendorId] },
            { gdprApplies: false }
        ]);
        if (!allowed) return log.debug('no consent');

        window.audienceProjectLayer ||= [];

        const pubco = this.#idStore.getId("pubCommonId") || this.#idStore.getId("sharedid");
        const id5id = this.#idStore.getId("id5id");
        const mbrid = this.#idStore.getId("mbrid");

        pubco && window.audienceProjectLayer.push(["setUserId", "pubco", pubco]);
        id5id && window.audienceProjectLayer.push(["setUserId", "id5id", id5id]);
        mbrid && window.audienceProjectLayer.push(["setUserId", "mbrid", mbrid]);

        log.notice('adding IDs to AudienceProjectLayer');

        loadScript({ src: url, node: document.head })
    }
}
